<template>
    <footer class="site-footer">
        <nav class="container">
            <div class="site-footer__main mobile">
                <div v-for="column in mobileColumns">
                    <div class="site-footer__section" v-for="section in column" :key="section.name">
                        <h3 :id="`footer-nav-${section.name}`" class="text-body">{{ section.label }}</h3>
                        <NavItemList :items="section.items" role="group" :aria-labelledby="`footer-nav-${section.name}`" />
                    </div>
                </div>
            </div>

            <div class="site-footer__main desktop">
                <div v-for="column in desktopColumns">
                    <div class="site-footer__section" v-for="section in column" :key="section.name">
                        <h3 :id="`footer-nav-${section.name}`" class="text-body">{{ section.label }}</h3>
                        <NavItemList :items="section.items" role="group" :aria-labelledby="`footer-nav-${section.name}`" />
                    </div>
                </div>
            </div>

            <div class="site-footer__mini">
                <ul class="site-footer__legal">
                    <li>
                        <ProLink :to="{ name: 'terms-conditions' }">{{ $t("navigation-footer.terms_and_conditions") }} </ProLink>
                    </li>
                    <li>
                        <ProLink :to="{ name: 'privacy-policy' }">{{ $t("navigation-footer.privacy_policy") }}</ProLink>
                    </li>
                    <li>
                        <ProLink :to="{ name: 'cookies-policy' }">{{ $t("navigation-footer.cookies_policy") }}</ProLink>
                    </li>
                    <li>
                        <LocaleDropdown class="footer-locale-dropdown" />
                    </li>
                </ul>
                <div class="site-footer__acknow text-body">
                    <span>{{ $t("navigation-footer.acknow") }}</span> <br />
                    {{ $t("navigation-footer.copyright_message", { year: new Date().getFullYear() }) }}
                </div>
            </div>
        </nav>
    </footer>
</template>

<script>
import LocaleDropdown from "@/components/LocaleDropdown";
import NavItemList from "@/components/navigation/NavItemsList";

export default {
    components: { NavItemList, LocaleDropdown },

    computed: {
        sections() {
            return {
                procreate: {
                    name: "procreate",
                    label: this.$t("navigation-procreate.main_link").product_title,
                    items: this.$t("navigation-procreate.menu_items"),
                },
                dreams: {
                    name: "dreams",
                    label: this.$t("navigation-dreams.main_link").product_title,
                    items: this.$t("navigation-dreams.menu_items"),
                },
                pocket: {
                    name: "pocket",
                    label: this.$t("navigation-pocket.main_link").product_title,
                    items: this.$t("navigation-pocket.menu_items"),
                },
                folio: {
                    name: "folio",
                    label: this.$t("navigation-folio.main_link").title,
                    items: this.$t("navigation-folio.menu_items"),
                },
                support: {
                    name: "support",
                    label: this.$t("navigation-sections.support"),
                    items: this.$t("navigation-footer.support_menu"),
                },
                connect: {
                    name: "connect",
                    label: this.$t("navigation-sections.connect"),
                    items: this.$t("navigation-connect.menu_items"),
                },
                discover: {
                    name: "discover",
                    label: this.$t("navigation-sections.discover"),
                    items: this.$t("navigation-explore.menu_items"),
                },
            };
        },

        mobileColumns() {
            return [
                [this.sections.procreate, this.sections.dreams, this.sections.pocket, this.sections.folio],
                [this.sections.support, this.sections.connect, this.sections.discover],
            ];
        },

        desktopColumns() {
            return [
                [this.sections.procreate],
                [this.sections.dreams, this.sections.pocket, this.sections.folio],
                [this.sections.support, this.sections.connect],
                [this.sections.discover],
            ];
        },
    },
};
</script>
